import "./QuizFactWidget.scss";
import "../../assets/images/electric-fact.svg";

export default function QuizFactWidget({
  headText,
  infoText,
  infoImg,
  backgroundColor,
}) {
  const imgSrc = infoImg ? require(`../../assets/images/${infoImg}`) : "";

  const containerStyle = {
    background: backgroundColor !== "white" ? "#524F47" : "white", // Default background color
  };

  return (
    <div className="quiz_fact_container" style={containerStyle}>
      <div className="badge_logo_bright">
        <img src={imgSrc} alt="" style={{ width: "15rem" }} />
      </div>
      {/* <Close className='quiz_fact_close' onClick={() => setQuizPopupOn(false)}/> */}
      {headText !== "" ? <p className="head_text">{headText}</p> : null}
      {infoText !== "" ? <p className="info_text">{infoText}</p> : null}
    </div>
  );
}
